import React,{useContext} from "react";
import { Context } from '../context/Context'
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/header/PageHeader";

import WhychooseCfd from "../components/Cfd/WhychooseCfd";
import IntroCfd from "../components/Cfd/IntroCfd";
import WhoisitforCfd from "../components/Cfd/WhoisitforCfd";
import FeaturesCfd from "../components/Cfd/FeaturesCfd";

export default function Cfd() {
  const {cfd} = useContext(Context)
  const {logo, tagline} = cfd
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader
        image={logo}
        PageTitle={tagline}
        Parent="Blog"
      />
      <WhychooseCfd/>
      <IntroCfd/>
      <WhoisitforCfd/>
      <FeaturesCfd/>
      <Footer />
    </Layout>
  );
}
